import { render, staticRenderFns } from "./PaddingFullCustoms.vue?vue&type=template&id=6bcc47be"
import script from "./PaddingFullCustoms.vue?vue&type=script&lang=js"
export * from "./PaddingFullCustoms.vue?vue&type=script&lang=js"
import style0 from "./PaddingFullCustoms.vue?vue&type=style&index=0&id=6bcc47be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports